/**
 * Field IDs for contact details form
 * @enum {string}
 */
export const ContactDetailsFieldIds = {
  FirstName: 'firstName',
  LastName: 'lastName',
  ShipstationEmail: 'shipstationEmail',
  AlternateEmail: 'alternateEmail',
  Company: 'company',
  Phone: 'phone',
  AdditionalInfo: 'additionalInfo',
};
